import { useEffect, useRef } from "react";

export default function Adsense({
  client,
  slot,
  className,
  style,
  layout,
  format,
}) {
  const adRef = useRef(null);

  useEffect(() => {
    if (!window.adsbygoogle || !adRef.current) return;

    try {
      // Prevent double-initialization
      if (!adRef.current.getAttribute("data-adsbygoogle-status")) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      // AdSense throws if pushed twice — ignore
    }
  }, []);

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle ${className || ""}`}
      style={style || { display: "block" }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-layout={layout}
      data-ad-format={format}
    />
  );
}
